import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({ configurationsList = [] }) => {
    const stats = useMemo(() => [
        { title: "Total Configs", value: configurationsList.length, icon: "bx-server", color: "primary" },
        { title: "Active Hosts", value: configurationsList.filter(c => c.status === "Active").length, icon: "bx-check-double", color: "success" },
        { title: "Inactive Hosts", value: configurationsList.filter(c => c.status === "Inactive").length, icon: "bx-error", color: "danger" },
        { title: "TLS / Secure", value: configurationsList.filter(c => c.encryption === "TLS" || c.encryption === "SSL").length, icon: "bx-badge-check", color: "info" },
    ], [configurationsList]);

    return (
        <Row className="mb-4">
            {stats.map((stat, index) => (
                <Col key={index} xl="3" md="6">
                    <Card className="border-0 shadow-sm mb-0">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className={`avatar-sm bg-${stat.color}-subtle text-${stat.color} rounded-3 p-2 me-3 d-flex align-items-center justify-content-center`}>
                                    <i className={`bx ${stat.icon} fs-3`}></i>
                                </div>
                                <div>
                                    <h6 className="text-muted mb-1">{stat.title}</h6>
                                    <h4 className="mb-0 fw-bold">{stat.value}</h4>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsCard;